export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', description: '浏览所有创意内容' },
  { slug: 'design', name: '视觉设计', icon: 'ri-palette-line', description: '平面设计、UI设计、插画作品' },
  { slug: 'photography', name: '摄影摄像', icon: 'ri-camera-line', description: '摄影作品、短片创作、Vlog记录' },
  { slug: 'writing', name: '文字创作', icon: 'ri-quill-pen-line', description: '诗歌、小说、散文、剧本创作' },
  { slug: 'music', name: '音乐音频', icon: 'ri-music-line', description: '原创音乐、翻唱、编曲、声音设计' },
  { slug: 'tech', name: '科技创意', icon: 'ri-cpu-line', description: '编程开发、数字艺术、AI创作' },
  { slug: 'handcraft', name: '手工制作', icon: 'ri-scissors-line', description: '手工艺、DIY、模型制作、饰品设计' },
  { slug: 'life', name: '生活方式', icon: 'ri-heart-line', description: '美食、旅行、穿搭、家居灵感' },
];

export const articles = [
  {
    id: 1,
    title: '从零开始学插画：新手必备的10个实用技巧',
    slug: 'illustration-tips-for-beginners',
    category: 'design',
    excerpt: '想要入门插画但不知道从何开始？本文为你整理了10个超实用的插画技巧，从线条练习到色彩搭配，手把手带你走进插画的世界。',
    content: `
      <p>插画是一种充满魅力的艺术表达方式，无论你是完全零基础的新手，还是有一定绘画功底的爱好者，都能在插画的世界里找到属于自己的创作乐趣。</p>
      <h2>1. 从线条开始</h2>
      <p>线条是插画的基础。每天花15分钟做线条练习，画直线、曲线、波浪线，让手和笔成为最好的朋友。不需要画得多完美，重要的是培养手感和肌肉记忆。</p>
      <h2>2. 掌握基本形状</h2>
      <p>圆形、方形、三角形——世界上所有的复杂图形都可以简化为这些基本形状的组合。学会用基本形状解构物体，你会发现画画突然变得简单了很多。</p>
      <h2>3. 色彩理论基础</h2>
      <p>了解色轮、互补色、类似色的概念。开始时不要使用超过3-5种颜色，先掌握少量颜色的搭配，再逐步扩展你的调色板。</p>
      <h2>4. 临摹与创新</h2>
      <p>临摹是学习的捷径，但不是终点。在临摹中理解构图、用色和技法，然后尝试加入自己的创意元素，逐步形成个人风格。</p>
      <h2>5. 善用参考素材</h2>
      <p>建立自己的灵感素材库，收集你喜欢的插画作品、摄影图片、色彩搭配。Pinterest和Behance都是非常好的灵感来源。</p>
      <h2>6. 工具选择</h2>
      <p>新手推荐从iPad+Procreate或数位板+Photoshop开始，这些工具学习曲线平缓，网上教程也非常丰富。</p>
      <h2>7. 构图法则</h2>
      <p>学习三分法、对角线构图、对称构图等基本法则。好的构图能让你的作品立刻提升一个档次。</p>
      <h2>8. 光影表现</h2>
      <p>理解光源方向、阴影和高光的关系。即使是最简单的扁平风格插画，恰当的光影处理也能让画面更有层次感。</p>
      <h2>9. 持续输出</h2>
      <p>给自己设定一个挑战，比如"每天一幅小画"或"每周一个主题系列"。持续输出不仅能提升技术，还能帮你找到自己的风格方向。</p>
      <h2>10. 加入社区</h2>
      <p>在cy社区分享你的作品，接受反馈，看看其他创作者的作品。一个活跃的社区是保持创作热情的最佳动力。</p>
    `,
    author: '小雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20artist%20portrait%20with%20warm%20smile%2C%20minimalist%20studio%20background%2C%20soft%20natural%20lighting%2C%20clean%20professional%20headshot&width=100&height=100&seq=avatar-xiaoyu&orientation=squarish',
    date: '2026-07-28',
    readTime: '8分钟',
    likes: 2341,
    comments: 186,
    tags: ['插画入门', '绘画技巧', '创意设计'],
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20digital%20illustration%20artwork%20on%20tablet%20with%20paint%20brushes%20and%20color%20palette%2C%20artistic%20studio%20atmosphere%2C%20warm%20lighting%2C%20creative%20workspace%20with%20plants%20and%20sketchbooks&width=800&height=500&seq=article-illustration-tips&orientation=landscape',
  },
  {
    id: 2,
    title: '城市夜拍指南：用手机拍出电影感大片',
    slug: 'city-night-photography-guide',
    category: 'photography',
    excerpt: '不需要昂贵的器材，只要一部手机和一些小技巧，你也能在城市夜晚拍出令人惊艳的照片。来学习这些简单却出效果的夜拍秘诀吧！',
    content: `
      <p>城市的夜晚有着白天无法比拟的魅力。霓虹灯、车流、雨后的街道——这些都是绝佳的拍摄素材。今天就来分享如何用手机拍出电影感十足的夜景照片。</p>
      <h2>选择合适的时机</h2>
      <p>蓝调时刻（日落后20-30分钟）是拍摄夜景的最佳时机。天空呈现深邃的蓝色，城市的灯光刚刚亮起，画面层次感最强。</p>
      <h2>稳定是王道</h2>
      <p>夜景拍摄最大的敌人是手抖。使用三脚架或者将手机靠在稳定的物体上。如果手持拍摄，记得屏住呼吸，手臂夹紧身体。</p>
      <h2>善用手机专业模式</h2>
      <p>调低ISO减少噪点，调慢快门速度捕捉更多光线。大部分手机的专业模式都能手动调整这些参数。</p>
      <h2>寻找光与影的对比</h2>
      <p>路灯下的剪影、橱窗的倒影、潮湿路面的反光——这些光影对比能为照片增添戏剧性和故事感。</p>
      <h2>后期处理锦上添花</h2>
      <p>使用Lightroom或VSCO进行后期调色。降低高光、提升阴影、增加一点对比度和锐度，照片立刻质感翻倍。</p>
    `,
    author: '阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20photographer%20portrait%20with%20camera%2C%20casual%20style%2C%20urban%20background%2C%20warm%20evening%20light%2C%20professional%20headshot&width=100&height=100&seq=avatar-ajie&orientation=squarish',
    date: '2026-07-25',
    readTime: '6分钟',
    likes: 1823,
    comments: 142,
    tags: ['手机摄影', '夜景拍摄', '摄影技巧'],
    image: 'https://readdy.ai/api/search-image?query=Stunning%20city%20nightscape%20photography%20with%20neon%20lights%20reflecting%20on%20wet%20street%2C%20cinematic%20color%20grading%2C%20urban%20atmosphere%2C%20warm%20and%20cool%20tone%20contrast&width=800&height=500&seq=article-night-photo&orientation=landscape',
  },
  {
    id: 3,
    title: '创意写作的秘诀：如何让你的文字更有感染力',
    slug: 'creative-writing-secrets',
    category: 'writing',
    excerpt: '写作不只是堆砌华丽的辞藻，更是用文字搭建一座通往读者内心的桥。掌握这些写作心法，让你的每个字都充满力量。',
    content: `
      <p>每个人都有一段独特的故事，但并不是每个人都知道如何将故事讲得动人。创意写作的核心不在于技巧的堆砌，而在于真诚的表达和对细节的捕捉。</p>
      <h2>从生活细节入手</h2>
      <p>最打动人的往往不是宏大的叙事，而是那些细微的、容易被忽略的瞬间。外婆煮的那碗面的温度、雨后泥土的气息、陌生人嘴角的一抹微笑。</p>
      <h2>建立情感共鸣</h2>
      <p>问问自己：读者为什么要关心这个故事？找到与读者共通的情感体验——爱、失去、成长、孤独——这些是人类共通的语言。</p>
      <h2>用具体代替抽象</h2>
      <p>不要写"他很伤心"，写"他蹲在墙角，手里攥着一张皱巴巴的照片，眼泪一滴一滴落在照片上那个人的笑容上"。具体，才有画面感。</p>
      <h2>节奏与留白</h2>
      <p>好的文字像音乐，有快有慢、有起有伏。该快的时候用短句制造紧张感，该慢的时候用长句营造氛围。适当的留白给读者想象的空间。</p>
      <h2>修改是最好的老师</h2>
      <p>第一稿只管写，不要回头修改。写完放一两天再读，你会发现很多可以改进的地方。好的作品是改出来的，不是写出来的。</p>
    `,
    author: '墨白',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20writer%20portrait%20in%20cozy%20bookstore%2C%20glasses%2C%20warm%20intellectual%20vibe%2C%20soft%20window%20light%2C%20professional%20headshot&width=100&height=100&seq=avatar-mobai&orientation=squarish',
    date: '2026-07-22',
    readTime: '7分钟',
    likes: 3156,
    comments: 278,
    tags: ['创意写作', '文学创作', '写作技巧'],
    image: 'https://readdy.ai/api/search-image?query=Cozy%20writing%20desk%20with%20notebook%20and%20pen%2C%20warm%20coffee%20cup%2C%20sunlight%20streaming%20through%20window%2C%20inspirational%20creative%20workspace%2C%20soft%20warm%20tones&width=800&height=500&seq=article-writing&orientation=landscape',
  },
  {
    id: 4,
    title: '独立音乐人入门：从卧室到录音棚的完整路径',
    slug: 'indie-music-beginner-guide',
    category: 'music',
    excerpt: '想做音乐但不知道从哪里开始？从设备选择到编曲混音，这份完整的独立音乐人入门指南帮你少走弯路，快速开启音乐创作之旅。',
    content: `
      <p>在这个人人都能成为创作者的时代，独立音乐的门槛已经大大降低。一台电脑、一个声卡、一支麦克风，你就可以在卧室里制作出专业水准的音乐作品。</p>
      <h2>基础设备清单</h2>
      <p>入门阶段你只需要：一台电脑、一个音频接口（声卡）、一副监听耳机和一支电容麦克风。总预算控制在3000元以内就能搭建一个不错的家庭工作室。</p>
      <h2>选择你的DAW</h2>
      <p>DAW（数字音频工作站）是你的创作核心。新手推荐Ableton Live或FL Studio，界面友好，教程资源丰富。Logic Pro适合Mac用户，功能强大且性价比极高。</p>
      <h2>学习基础乐理</h2>
      <p>不需要成为乐理大师，但基本的音阶、和弦进行、节奏型是必须掌握的。花两周时间学习基础乐理，会让你的创作效率提升数倍。</p>
      <h2>从模仿开始</h2>
      <p>选一首你喜欢的歌，尝试从头到尾复刻它的编曲。这个过程能让你快速理解歌曲结构、音色设计和混音技巧。</p>
      <h2>发布你的作品</h2>
      <p>通过网易云音乐、QQ音乐的独立音乐人平台发布作品。在cy社区分享你的创作过程，与其他音乐人交流心得。</p>
    `,
    author: '节奏猫',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20musician%20with%20headphones%20in%20home%20studio%2C%20creative%20vibe%2C%20warm%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-jiezoumao&orientation=squarish',
    date: '2026-07-20',
    readTime: '9分钟',
    likes: 1567,
    comments: 98,
    tags: ['独立音乐', '音乐制作', '编曲教程'],
    image: 'https://readdy.ai/api/search-image?query=Home%20music%20studio%20with%20MIDI%20keyboard%20and%20studio%20monitors%2C%20warm%20ambient%20lighting%2C%20creative%20music%20production%20setup%2C%20cozy%20atmosphere%20with%20acoustic%20panels&width=800&height=500&seq=article-music&orientation=landscape',
  },
  {
    id: 5,
    title: 'AI绘画实战：Midjourney进阶提示词编写指南',
    slug: 'ai-art-midjourney-advanced',
    category: 'tech',
    excerpt: '同样是AI绘画工具，为什么别人能生成惊艳的作品而你总是差一点？关键在于提示词的编写技巧。这份进阶指南让你的AI创作如虎添翼。',
    content: `
      <p>AI绘画已经从新奇玩具变成了真正的创作工具。掌握好提示词（Prompt）的编写技巧，你就能让AI成为你创意表达的得力助手。</p>
      <h2>提示词的基本结构</h2>
      <p>一个好的提示词通常包含：主体描述 + 风格指定 + 技术参数 + 氛围描述。例如："一位穿着汉服的少女站在樱花树下，吉卜力风格，柔和光线，高细节，4K"。</p>
      <h2>风格关键词大全</h2>
      <p>学习不同艺术风格的关键词：赛博朋克(cyberpunk)、水墨画(ink wash painting)、极简主义(minimalist)、蒸汽波(vaporwave)、巴洛克(baroque)——掌握这些词汇能让你的创作风格无限扩展。</p>
      <h2>负向提示词的艺术</h2>
      <p>告诉AI你不想要什么和告诉它你想要什么同样重要。使用--no参数排除不想要的元素，能让生成结果更精准。</p>
      <h2>参数调优实战</h2>
      <p>理解--ar（画面比例）、--chaos（创意度）、--stylize（风格化程度）等参数的作用，通过调整这些参数获得不同风格的输出。</p>
      <h2>迭代优化思维</h2>
      <p>不要期待一次就能得到完美结果。把AI生成当作迭代过程：初次生成→选择最佳方向→微调提示词→继续生成→最终选择。</p>
    `,
    author: '数字游民',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20tech%20creative%20portrait%2C%20modern%20style%2C%20digital%20artist%20vibe%2C%20warm%20studio%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-digital&orientation=squarish',
    date: '2026-07-18',
    readTime: '10分钟',
    likes: 4521,
    comments: 367,
    tags: ['AI绘画', 'Midjourney', '数字艺术'],
    image: 'https://readdy.ai/api/search-image?query=Stunning%20AI%20generated%20digital%20artwork%20gallery%20display%2C%20creative%20studio%20with%20large%20screen%20showing%20colorful%20art%2C%20modern%20workspace%2C%20warm%20ambient%20lighting&width=800&height=500&seq=article-aI-art&orientation=landscape',
  },
  {
    id: 6,
    title: '手工皮具入门：制作属于你的第一件皮具作品',
    slug: 'leather-craft-beginner',
    category: 'handcraft',
    excerpt: '手工皮具不仅是实用的物品，更承载着匠人的温度和心意。跟着这份教程，用一针一线缝制出独一无二的皮具作品。',
    content: `
      <p>在这个机器制造的时代，手工皮具的温暖质感显得尤为珍贵。今天带你走进手工皮具的世界，从最基础的卡包开始你的皮具之旅。</p>
      <h2>基础工具准备</h2>
      <p>入门必备工具：裁皮刀、菱斩、手缝针、蜡线、边线器、打磨棒、床面处理剂。一套基础工具大约300-500元就可以备齐。</p>
      <h2>皮革选择</h2>
      <p>新手推荐植鞣革，硬度适中，容易塑形，而且随使用时间会形成独特的色泽变化。厚度选择1.5-2.0mm最为合适。</p>
      <h2>打斩与缝线</h2>
      <p>打斩要垂直、力度均匀，这是缝线美观的基础。手缝采用双针交叉法，每一针都要拉紧，保持线迹均匀。这需要练习，但掌握了就终身受用。</p>
      <h2>封边处理</h2>
      <p>好的封边能让作品质感提升一个档次。先打磨平整，再上封边液，反复打磨直至光滑如镜。这个过程需要耐心，但成品绝对值得。</p>
    `,
    author: '手工匠人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20craftsman%20in%20workshop%2C%20leather%20tools%20background%2C%20warm%20artisan%20vibe%2C%20professional%20headshot&width=100&height=100&seq=avatar-craftsman&orientation=squarish',
    date: '2026-07-15',
    readTime: '7分钟',
    likes: 987,
    comments: 76,
    tags: ['手工皮具', 'DIY教程', '手工艺'],
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20handcrafted%20leather%20goods%20on%20wooden%20workbench%2C%20leather%20crafting%20tools%2C%20warm%20workshop%20lighting%2C%20artisan%20atmosphere%2C%20natural%20textures&width=800&height=500&seq=article-leather&orientation=landscape',
  },
  {
    id: 7,
    title: '打造你的灵感角落：创意工作空间布置指南',
    slug: 'creative-workspace-design',
    category: 'life',
    excerpt: '一个好的工作空间能极大提升创作效率和灵感。不需要大房子，也不需要昂贵的家具，几个简单技巧就能打造属于你的创意角落。',
    content: `
      <p>对于创意工作者来说，工作空间不仅仅是坐的地方，更是灵感的孵化器。一个精心布置的角落能让你的创作效率翻倍。</p>
      <h2>光线是第一要素</h2>
      <p>自然光是最佳选择。把桌子放在窗边，让阳光洒在你的工作台上。如果自然光不足，选择色温4000K-5000K的台灯，接近自然光色温。</p>
      <h2>色彩心理学</h2>
      <p>暖色调（橙色、黄色）能激发创造力，绿色能缓解眼疲劳，白色和浅灰让空间显得更大。避免使用过于刺激的红色或压抑的深色。</p>
      <h2>绿植的力量</h2>
      <p>在桌面上放一盆小植物，不仅能净化空气，研究表明绿色植物能提升15%的创造力和专注力。</p>
      <h2>灵感墙</h2>
      <p>在墙上创建一个灵感板，贴上你喜欢的图片、名言、草图。视觉化的灵感收集能让你的创意源源不断。</p>
      <h2>保持整洁</h2>
      <p>杂乱的桌面＝杂乱的思维。每天工作结束后花5分钟整理桌面，第二天开始工作时你会感谢昨晚的自己。</p>
    `,
    author: '空间设计师Linda',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20designer%20portrait%20in%20bright%20studio%2C%20warm%20smile%2C%20creative%20professional%20headshot&width=100&height=100&seq=avatar-linda&orientation=squarish',
    date: '2026-07-12',
    readTime: '5分钟',
    likes: 2789,
    comments: 203,
    tags: ['工作空间', '创意生活', '家居布置'],
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20creative%20workspace%20with%20plants%20and%20warm%20lighting%2C%20minimalist%20desk%20setup%2C%20inspiration%20board%20on%20wall%2C%20cozy%20home%20office%20atmosphere&width=800&height=500&seq=article-workspace&orientation=landscape',
  },
  {
    id: 8,
    title: '平面设计趋势2026：这些风格将主宰今年',
    slug: 'graphic-design-trends-2026',
    category: 'design',
    excerpt: '设计趋势每年都在变化，2026年有哪些风格值得关注？从极简主义回潮到AI辅助设计，一文看懂今年的设计风向标。',
    content: `
      <p>设计的世界从来不缺变化。2026年，我们看到了一些有趣的设计趋势正在兴起，它们或许会定义未来几年的视觉语言。</p>
      <h2>有机极简主义</h2>
      <p>不同于冷冰冰的传统极简，有机极简在简洁中融入了自然的曲线和不完美的手工感。柔和的圆角、自然的配色、适度的留白——这是2026年最值得关注的设计语言。</p>
      <h2>AI辅助设计</h2>
      <p>AI不再是设计师的对手，而是最强辅助。从配色方案生成到布局建议，AI工具正在重塑设计工作流。会用AI的设计师效率是传统设计师的3倍以上。</p>
      <h2>可变字体</h2>
      <p>可变字体技术成熟了。一个字体文件就能实现粗细、宽度、倾斜度的无限变化，为动态排版带来了全新的可能性。</p>
      <h2>复古未来主义</h2>
      <p>融合了80年代霓虹美学和现代设计语言，复古未来主义正在各大品牌中流行。想想赛博朋克遇上包豪斯的感觉。</p>
    `,
    author: '设计师小王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20graphic%20designer%20portrait%20in%20modern%20office%2C%20creative%20style%2C%20warm%20professional%20headshot&width=100&height=100&seq=avatar-designerw&orientation=squarish',
    date: '2026-07-10',
    readTime: '6分钟',
    likes: 1987,
    comments: 155,
    tags: ['设计趋势', '平面设计', '视觉设计'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20graphic%20design%20studio%20with%20colorful%20posters%20on%20wall%2C%20minimalist%20desk%20with%20macbook%2C%20creative%20atmosphere%2C%20warm%20natural%20lighting&width=800&height=500&seq=article-design-trends&orientation=landscape',
  },
];

export const featuredWorks = [
  {
    id: 1,
    title: '梦境系列插画',
    author: '小雨',
    category: '视觉设计',
    likes: 2341,
    image: 'https://readdy.ai/api/search-image?query=Dreamy%20surreal%20digital%20illustration%20with%20floating%20islands%20and%20soft%20pastel%20colors%2C%20fantasy%20art%20style%2C%20dreamlike%20atmosphere%2C%20warm%20ethereal%20lighting&width=600&height=450&seq=work-dream-series&orientation=landscape',
  },
  {
    id: 2,
    title: '城市的呼吸',
    author: '阿杰',
    category: '摄影摄像',
    likes: 1823,
    image: 'https://readdy.ai/api/search-image?query=Urban%20street%20photography%20at%20sunset%20with%20warm%20golden%20light%2C%20city%20silhouette%2C%20cinematic%20mood%2C%20atmospheric%20composition&width=600&height=450&seq=work-city-breath&orientation=landscape',
  },
  {
    id: 3,
    title: '夏日序曲',
    author: '墨白',
    category: '文字创作',
    likes: 3156,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20handwritten%20poetry%20on%20aged%20paper%20with%20dried%20flowers%2C%20vintage%20literary%20aesthetic%2C%20warm%20sunlight%2C%20soft%20romantic%20atmosphere&width=600&height=450&seq=work-summer-prelude&orientation=landscape',
  },
  {
    id: 4,
    title: '电子梦境EP',
    author: '节奏猫',
    category: '音乐音频',
    likes: 1567,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20music%20album%20cover%20design%20with%20waveforms%20and%20neon%20colors%2C%20electronic%20music%20vibe%2C%20dark%20background%20with%20vibrant%20accents&width=600&height=450&seq=work-electronic-dream&orientation=landscape',
  },
  {
    id: 5,
    title: 'AI山海经',
    author: '数字游民',
    category: '科技创意',
    likes: 4521,
    image: 'https://readdy.ai/api/search-image?query=Mythical%20Chinese%20creatures%20reimagined%20with%20digital%20art%2C%20fusion%20of%20ancient%20mythology%20and%20futuristic%20style%2C%20vibrant%20colors%2C%20detailed%20artwork&width=600&height=450&seq=work-ai-shanhaijing&orientation=landscape',
  },
  {
    id: 6,
    title: '时光皮具系列',
    author: '手工匠人',
    category: '手工制作',
    likes: 987,
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20leather%20wallet%20and%20bag%20collection%20on%20rustic%20wooden%20table%2C%20artisan%20craftsmanship%2C%20warm%20natural%20lighting%2C%20rich%20brown%20textures&width=600&height=450&seq=work-leather-series&orientation=landscape',
  },
];

export const faqs = [
  {
    question: 'cy社区是免费的吗？',
    answer: '是的，cy社区对所有创意青年完全免费开放！你可以免费注册、浏览内容、发布作品、参与讨论。我们相信创意不应该有门槛，每个人都应该有展示才华的舞台。未来我们可能会推出一些增值服务，但核心的社区功能将永远保持免费。',
  },
  {
    question: '如何在cy社区发布我的作品？',
    answer: '注册账号后，点击页面顶部的"发布作品"按钮，选择作品分类，上传你的图片/视频/音频/文字作品，填写作品描述和标签，就可以发布了。我们支持多种格式的作品上传，让你的创意以最佳方式呈现。',
  },
  {
    question: 'cy社区有哪些创意分类？',
    answer: '目前cy社区涵盖视觉设计、摄影摄像、文字创作、音乐音频、科技创意、手工制作、生活方式等七大创意领域。每个分类下还有更细分的标签，方便你精准找到感兴趣的内容和志同道合的伙伴。',
  },
  {
    question: '我可以和其他创作者合作吗？',
    answer: '当然可以！cy社区鼓励创作者之间的合作与交流。你可以在作品下方留言互动，通过私信联系感兴趣的创作者，也可以在我们的"寻找搭档"专区发布合作需求。很多优秀的作品都是跨领域合作的成果。',
  },
  {
    question: '如何保护我的原创作品版权？',
    answer: 'cy社区非常重视原创保护。我们提供了作品首发时间戳认证功能，所有发布的作品都会自动记录发布时间。如果发现侵权行为，你可以通过举报功能或联系客服进行维权。我们也建议创作者在发布重要作品前自行做好版权登记。',
  },
];

export const stats = [
  { label: '注册创作者', value: '12,800+', icon: 'ri-user-star-line' },
  { label: '创意作品', value: '58,000+', icon: 'ri-gallery-line' },
  { label: '日均互动', value: '3.2万+', icon: 'ri-chat-1-line' },
  { label: '合作项目', value: '1,500+', icon: 'ri-hand Heart-line', displayIcon: 'ri-hand-heart-line' },
];

export const testimonials = [
  {
    name: '小雨',
    role: '插画师',
    content: '在cy社区认识了很多志同道合的朋友，大家的反馈和建议让我的插画水平突飞猛进。这里是我每天的灵感源泉！',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20artist%20with%20warm%20smile%2C%20casual%20style%2C%20studio%20background%2C%20professional%20headshot&width=100&height=100&seq=testimonial-xiaoyu&orientation=squarish',
  },
  {
    name: '阿杰',
    role: '摄影师',
    content: '从摄影小白到现在能接到商业约拍，cy社区的摄影板块给了我太多帮助。这里的氛围真的很棒，大家都愿意分享经验。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20photographer%20with%20camera%2C%20friendly%20smile%2C%20outdoor%20background%2C%20professional%20headshot&width=100&height=100&seq=testimonial-ajie&orientation=squarish',
  },
  {
    name: '墨白',
    role: '自由撰稿人',
    content: '在这里发布了第一篇短篇小说后收到了意想不到的热烈反响，给了我继续写作的巨大动力。cy社区是每个创作者的第二个家。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20writer%20with%20glasses%2C%20warm%20intellectual%20look%2C%20bookstore%20background%2C%20professional%20headshot&width=100&height=100&seq=testimonial-mobai&orientation=squarish',
  },
];